import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { CheckboxProps } from "./Checkbox.types";

const Checkbox = forwardRef<HTMLInputElement, PropsWithChildren<CheckboxProps>>(
  ({ size = "small", className, onChange, ...checkboxProps }, forwardedRef) => {
    return (
      <input
        ref={forwardedRef}
        type="checkbox"
        className={cn(
          "rounded border-neutral-700 bg-white text-blue-600 transition-all duration-200 checked:border-primary checked:bg-primary focus:outline focus:outline-1 focus:outline-primary focus:ring-0 focus:ring-offset-0 disabled:pointer-events-none disabled:opacity-50",
          {
            "h-4 w-4": size === "small",
            "h-5 w-5": size === "medium",
          },
          className,
        )}
        onChange={(event) => {
          if (onChange) onChange(event.currentTarget.checked);
        }}
        {...checkboxProps}
      />
    );
  },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
